(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('grcPlanInitiativeAddController', Controller);

    Controller.$inject = ['$scope', 'businessPlanningService', 'notificationService'];

    function Controller($scope, businessPlanningService, notificationService) {

        // Select Owner Delegate
        $scope.selectOwnerDelegate = function (person) {
            $scope.boxModel.OwnerDelegate = person;
            $scope.boxModel.OwnerDelegateID = person.ItemPersonID;
            $scope.ctxt.form.$setValidity('RequiredOwnerDelegate', true);
            $scope.pageIsDirty();
        };

        // Create
        $scope.create = function () {
            $scope.ctxt.isLoading = true;

            return businessPlanningService
                .createOrUpdateInitiative($scope.boxModel)
                .then(function () {
                    $scope.boxContext.onCreated();

                    notificationService.notify('The initiative has been created');
                    $scope.pageIsNotDirty();
                })
                .finally(function () {
                    $scope.ctxt.isLoading = false;
                });
        };

        // Cancel
        $scope.cancel = function () {
            $scope.boxContext.onCancel();
        };
    }
})();